import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { NavegacaoStore } from '@layout/store/navegacao.store';
import { Entrada } from '@shared/interfaces/entrada';
import { format, parse } from 'date-fns';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { filter, map } from 'rxjs';

function pathEhRaizProntuario(url: string): boolean {
  const path = url.split('?')[0].split('#')[0];
  return /^\/prontuario\/\d+\/?$/.test(path);
}

@Component({
  selector: 'app-info-bar-prontuario',
  templateUrl: './info-bar-prontuario.component.html',
  styleUrl: './info-bar-prontuario.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SkeletonModule, TooltipModule],
  host: {
    '[style.display]': 'exibir()',
  },
})
export class InfoBarProntuarioComponent {
  private readonly router = inject(Router);
  protected readonly store = inject(NavegacaoStore);
  private readonly urlAtual = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects),
    ),
    { initialValue: this.router.url },
  );

  protected readonly exibir = computed(() => {
    if (!this.store.emProntuario()) {
      return 'none';
    }

    if (pathEhRaizProntuario(this.urlAtual())) {
      return 'none';
    }

    return 'block';
  });

  protected readonly camposSkeleton: readonly number[] = [1, 2, 3, 4, 5];

  protected obterNomeLeito(entrada: Entrada): string {
    return entrada.internacao?.leito?.nome ?? 'Sem leito';
  }

  protected obterDataNascimentoComIdade(entrada: Entrada): string {
    const dataOriginal = entrada.paciente.dataNascimento;
    const idade = entrada.paciente.idade ?? '';
    const data = dataOriginal ? this.formatarDataNascimento(dataOriginal) : '';

    if (data && idade) {
      return `${data} · ${idade}`;
    }

    return data || idade || '—';
  }

  private formatarDataNascimento(data: string): string {
    try {
      return format(parse(data, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy');
    } catch {
      return data;
    }
  }
}
